import React from 'react'
import { Layout, Header } from 'app/theme/layout'
import { Link } from 'react-router-dom'
import ImageHero from 'app/theme/ImageHero'
import NavbarFixed from 'app/theme/NavbarFixed'
import weddingHeroImage from 'assets/img/wedding-catering.jpg'
import LeadModal from 'app/leads/LeadModal'
import { useModalState } from 'lib/modal'

export default function WeddingFAQPage(props) {
  const { openModal, ...modalState } = useModalState()

  const {
    title = 'Food Truck Wedding Catering',
    description = 'We’re your culinary matchmaker. At Roaming Hunger, our technology and expertise pairs you with your perfect catering experience in 45 days or less.',
  } = props

  return (
    <Layout header={<Header occasionMenu />}>
      <ImageHero
        imageUrl={weddingHeroImage}
        title={title}
        onButtonClick={openModal}
        description={description}
      />
      <a name="submenu"></a>
      <NavbarFixed menuItems={navMenu} onButtonClick={openModal}/>
      <WeddingFrequentlyAskedQuestions />
      <LeadModal
        {...modalState}
      />
    </Layout>
  )
}

const navMenu = [
  {
    title: 'Wedding Catering',
    url: '/food-truck-catering/food-truck-wedding/',
  },
  {
    title: 'Frequently Asked Questions',
    url: '/food-truck-catering/wedding-frequently-asked-questions/#submenu',
    active: true
  },
]

function WeddingFrequentlyAskedQuestions() {
  return (
    <div className="container">
      <h2 className="text-center text-navy text-4xl font-platform leading-tight md:leading-normal mt-10 mb-10">
        Frequently Asked Questions
      </h2>
      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          1. How does food truck wedding catering work?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Food truck wedding catering is similar to traditional wedding catering. 
          It is for private rehearsal dinners, reception dinners, late night snacks, 
          desserts, or day-after brunches and is paid for by the host.
        </p>
        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          Based on your details, Roaming Hunger will get you available catering options 
          with menus and pricing. All you have to do is pick the caterer that fits 
          your tastes and pay for it.
        </p>
        <p className="md:text-base text-lg font-light text-gray-900">
          Just make sure you have a venue that allows outside food and make sure 
          there is enough space for the caterer (especially if it’s a full sized food truck) 
          to park and set up.
        </p>
        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          And if you need extra help with coordination, our Roaming Hunger Personalized 
          Service can take over the catering logistics and planning.
        </p>
        <p className="md:text-base text-lg font-light text-gray-900">
          The best part is that you don’t need to worry about payment the day 
          of the wedding. All you have to do is enjoy delicious food with your guests!
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl my-4">
          2. Why should I work with Roaming Hunger vs. booking a food truck
          myself?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900 mb-4">
          We find that these are the things our clients value most:
        </p>
        <ul className="text-gray-900 font-light list-disc mt-0">
          <li className="ml-10">
            <b className="font-bold">The Ultimate Search</b> - We reach out to
            every local, available food truck that’s a good fit and gather their
            menus into a proposal for your review. Let us do the legwork so you
            don’t have to.
          </li>
          <li className="ml-10">
            <b className="font-bold">The Largest Network of Food Trucks</b> - 
            With over 23,000 vendors in our network, we can help you find all 
            the options in all major metro areas in the US and Canada. 
            More rural areas may have less options. 
          </li>
          <li className="ml-10">
            <b className="font-bold">Service Guarantee</b> - We make sure you
            get fantastic service on your wedding day. And If something does go
            wrong, we will find a way to make it right. Learn more about our
            100% Roaming Hunger Service Guarantee.
          </li>
          <li className="ml-10">
            <b className="font-bold">Peace of Mind</b> - Every food truck we
            work with must serve safely and legally at your wedding. We secure
            all the necessary paperwork, including contracts, W9s, certificates
            of insurance, and health and business permits.
          </li>
          <li className="ml-10">
            <b className="font-bold">Personalized Service When You Need It</b> - See below for more details.
          </li>
        </ul>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          3. What is Personalized Service?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
        If you ever need Roaming Hunger to handle all the logistics of finding a wedding caterer, 
        our Personalized Service is the way to go. You’ll be connected to a catering expert 
        who will help you find exactly what you’re looking for. 
        For details and pricing please 
        go to our  <a className="text-blue" href="https://roaminghunger.com/blog/16258/personalized-service">Personalized Service page.</a>
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          4. Does my venue need to be booked already?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Yes, you should have a venue booked AND it must be “food truck friendly.” 
          That means it allows outside catering and it has the proper space for a 
          food truck to park and safely prepare food.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          5. Can a food truck serve at any wedding venue?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          No, you will need answers to the three questions below to determine if
          food truck catering is possible:
        </p>

        <ol className="list-decimal font-light text-gray-900 my-4">
          <li className="ml-10 leading-normal">
            Can a food truck physically get to the venue?
          </li>
          <li className="ml-10 leading-normal">
            Does the venue itself allow food trucks to serve there?
          </li>
          <li className="ml-10 leading-normal">
            Is there a legal, flat parking space for the food truck to serve
            your guests?
          </li>
        </ol>

        <p className="md:text-base text-lg font-light text-gray-900">
          If you’re considering an open field or mountain campsite for a venue,
          you should know that many food trucks aren’t able or willing to drive
          roads that have a steep hill, are windy, or are unpaved. The risk of
          an accident or getting stuck is just too high.
        </p>

        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          Many venues will require you to use their “in-house” or “preferred
          caterers” only. Make sure to ask the venue if they allow “outside
          catering” from food trucks.
        </p>

        <p className="md:text-base text-lg font-light text-gray-900">
          When the truck arrives, will they have a legal, flat space to park?
          See the below FAQ “Where can food trucks park?” for more info.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          6. Where can food trucks park?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          The food truck will expect you to provide a designated parking space.
        </p>

        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          If the truck is parking on private property, you simply need
          permission from the property owner. If your venue or private property
          does not have space for the food truck to park, please investigate
          nearby parking options convenient to the venue.
        </p>

        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          If you would like the truck to park on public property like a street,
          you can, 1) park a car in the space until the truck arrives, or 2)
          contact the city to have a space reserved (additional fees may apply).
          Also, some cities have specific restrictions on where food trucks can
          serve and for how long, so be sure to check with your local government
          (typically the Department of Public Works).
        </p>

        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          You may also be able to park it in a nearby pay parking lot for a
          negotiated rate with the lot owner.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          7. What are the dimensions of a food truck?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Truck dimensions vary, but they are typically 16' to 28' long, 10'
          high and 8' wide. Food carts and trailers are significantly smaller.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          8. How far will a food truck travel?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Usually the maximum time a food truck is willing to travel is about
          two hours each way. If you are requesting a venue outside of their
          normal service area, expect to pay more to compensate them for the
          additional time, gas, and any special travel fees like tolls or
          overnight accommodations.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          9. Do all Roaming Hunger vendors have health permits and insurance?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Roaming Hunger requires all the foods trucks we work with for events
          and catering to have a health permit and insurance. We keep vendor
          certificates of insurance on file and will be able to provide you with
          a copy if needed. Roaming Hunger does not provide any additional
          permits, including special event permits required by some local
          governments, Please check with the appropriate government agencies to
          ensure you have acquired all necessary permits.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          10. What kind of food is available?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          In most major cities, there’s a wide variety of cuisine that food
          trucks serve. Also, trucks are flexible! Most are able to offer at
          least one vegetarian, vegan, gluten-free or allergy-free option in
          their customized menu for you. If you have a specific request, be sure
          to ask.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          11. Can a food truck do buffet, stations, or family style?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Besides the classic “order at the window” option, some food trucks 
          are able to do appetizers, buffet, stations, or even family-style 
          dinner services. You can also check out our blog post to learn 
          more about the <a className="text-blue" href="https://roaminghunger.com/blog/14232/how-to-get-great-wedding-catering-for-cheap">pros and cons of different service styles.</a>
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          12. What trucks are available for my wedding?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          After you give us your event details, we will look for available caterers and give you a 
          proposal with menu and pricing details. With over 23,000 food trucks and 
          caterers in our network, we have trucks all over the US and Canada.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          13. What if I want more than one food truck at my event?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Food trucks are typically able to serve 60 - 100 guests per hour. Depending on the 
          number of guests, time, and menu, the optimal number of trucks for an event can vary.
        </p>
        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          Once you book the truck or if you opt into our Personalized Service, ask for 
          advice about having more than one truck. Each wedding catering 
          is different, so the answer may vary.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          14. How can I get started booking a truck for my wedding?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          If your event is hosted or you are paying for everyone’s food, click
          the Get Started button at the top of the page or this link to fill out
          your information:{' '}
          <Link
            to={{ pathname: '/food-truck-catering/food-truck-wedding/' }}
            className="text-blue"
          >
            food truck catering
          </Link>
          . Check "host" for “Who’s Paying?” and make sure to select
          “Wedding/Rehearsal Dinner” as your occasion.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          15. Do you need a deposit and how much is it?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          We only require a deposit if you choose 
          our <a className="text-blue" href="https://roaminghunger.com/blog/16258/personalized-service">Personalized Service</a> option. 
          The deposit is refundable if you don’t book. Currently the deposit is $500 (subject to change).
        </p>

        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          Otherwise, in most cases you will have to authorize your credit card 
          for $25 (amount subject to change) in order for us to send 
          your request to caterers in your area.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          16. How soon should I expect food truck menus from Roaming Hunger
          after I retain its services?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          You will get menus and quotes from interested caterers within a few days and 
          we'll let you know every time a caterer applies. Caterers have 48 hours 
          to submit a menu and quote for your event after we send them your event details.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          17. What if I don't get any catering options for my wedding?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900 mb-4">
          In the case that no caterer submits for your event, there may be a couple of reasons:
        </p>

        <ul className="text-gray-900 font-light list-disc">
          <li className="ml-10">your venue is located in a more rural area</li>
          <li className="ml-10">
            you want options more than six months before your wedding
          </li>
          <li className="ml-10">you have very specific cuisine requirements</li>
          <li className="ml-10">your budget is too low</li>
        </ul>

        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          If you believe our <a className="text-blue" href="https://roaminghunger.com/blog/16258/personalized-service">Personalized Service</a> can help, go here to opt-in.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          18. How does payment work?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          When you book the caterer, you will pay the full amount of the catering 
          to Roaming Hunger. We will disperse most of your payment to the truck 
          after your wedding to guarantee you get fantastic day-of service from them.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          19. How much does food truck wedding catering cost?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Pricing varies greatly depending on the number of guests, travel time, 
          length of service, and style of service. Keep in mind that all 
          Roaming Hunger prices already include taxes and fees! 
        </p>
        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          Here are some examples of pricing based on a 100 guest minimum.
        </p>

        <ul className="text-gray-900 font-light list-disc">
          <li className="ml-10">
            Most of our wedding clients spend between $1500 and $6000 
            for their wedding reception dinner
          </li>
          <li className="ml-10">
            For late night snacks or rehearsal dinner expect to spend $1300 - $4500
          </li>
          <li className="ml-10">
            For an espresso drink or dessert truck, budget $1000 - $2000
          </li>
        </ul>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          20. Why won't the cost go any lower, even with fewer people?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Every food truck has a minimum required cost to come out and serve. 
          While each caterer has a different minimum, they are there to pay 
          for travel, staff, and other expenses. If you have a small guest 
          count, try adding dessert, drinks and appetizers or a longer 
          service time to get the most for your money.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          21. How long do I have to decide which food truck I would like to
          book?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          With over 23,000 vendors in our network, we're confident 
          that we can take you from “no idea” to booked caterer in a 
          few days! Here’s our process - after you submit and confirm 
          your event details, we will send out a request to vendors in 
          your area and get you a catering proposal within 48 hours. 
          You’ll be able to choose the vendor you want before the proposal 
          expires (24 hours). If you need more time we can be flexible, 
          but we cannot guarantee that trucks will hold your date. 
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          22. What if I have more people show up on the day of the event than I
          expected?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Food trucks will come prepared to serve the number of guests agreed upon. 
          Roaming Hunger cannot guarantee that the truck will come prepared to 
          serve any additional guests. In most cases, trucks will bring 10% more 
          product to provide any additional servings as needed.
        </p>
        <p className="md:text-base text-lg font-light text-gray-900 my-4">
          However, we advise speaking with your caterer once you book them. 
          If, at your direction, the caterer does serve extra guests, payment 
          for those additional meals will be due upon completion of the 
          event. The cost of each additional meal will be specified in advance 
          at the time of booking.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          23. I have a food truck coming to my event. What do I need to provide?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          Food trucks are self-contained mobile kitchens and only need access to
          a restroom for their staff during the event. If you want to avoid
          generator noise or are parking a truck inside, provide a power outlet
          for the truck. Disposable serving wares and a trash can are usually
          provided by the truck. Extra trash cans are strongly advised. If you
          would like a place for your guests to sit and eat, you will need to
          provide tables and chairs. If you would like your tables bussed, this
          will require additional staffing provided either by you, or the food
          truck at an additional cost. Otherwise, trucks just show up, serve
          your guests delicious food, and drive away with all the mess leaving
          your event location clean and tidy - it’s super convenient!
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          24. What if I need to cancel or reschedule my event?
        </h3>
        <p className="md:text-base text-lg font-light text-gray-900">
          If you need to reschedule your food truck catering, we will make our
          best effort to work with the confirmed food truck to reschedule your
          event date or time. If we are not able to accommodate your request,
          you will be subject to the cancellation policy as outlined in the
          catering agreement.
        </p>
      </div>

      <div align="left">
        <h3 className="text-navy text-2xl mt-4 mb-2">
          If you haven't already clicked the button
          to submit a food truck request, please do that now!{' '}
          <a
            href="/food-truck-catering/food-truck-wedding/"
            className="text-blue"
          >
            Get started here
          </a>
          .
        </h3>
      </div>
    </div>
  )
}
